// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let ProfilePageRelay = require("./ProfilePageRelay.bs.js");
let JsxRuntime = require("react/jsx-runtime");
let SettingsPageHeader = require("./SettingsPageHeader.bs.js");

function ProfilePage(props) {
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx(SettingsPageHeader.make, {
        title: "TAN Profile"
      }),
      JsxRuntime.jsx(ProfilePageRelay.make, {})
    ],
    className: "space-y-8 rounded bg-white p-6 shadow-sm"
  });
}

let make = ProfilePage;

exports.make = make;
/* ProfilePageRelay Not a pure module */
